/**
 * 2) « Mes crédits actifs » (SPEC MC1, MC3 ; retours M3, M4) — maquette 17-compte, cartes `.wallet`.
 * Données = UserProfile.tsx Credits() (GET client/services, forfaits non expirés avec au moins une
 * séance, 4 au plus comme Services/ServicesList.tsx) ; tri par expiration la plus proche d'abord.
 */
import { useListClientServices } from 'hooks/useApiQueries';
import { useMemo } from 'react';
import { Link } from 'react-router-dom';
import { accountWallets, isExpiringSoon, walletPercent } from '../lib/credits';
import { fmtDateExpiry, toDate } from '../lib/format';
import { SectionHead } from './Ui';

/** = Services/ServicesList.tsx : 4 forfaits au plus sur Mon compte. */
const WALLETS_ON_ACCOUNT = 4;

export function Wallets() {
  const { data: services, isLoading } = useListClientServices();
  const wallets = useMemo(() => accountWallets(services), [services]);
  const shown = wallets.slice(0, WALLETS_ON_ACCOUNT);

  return (
    <section className="mmv2-acct-section" aria-labelledby="mmv2-acct-credits">
      <SectionHead
        id="mmv2-acct-credits"
        title="Mes crédits actifs"
        link={wallets.length ? { to: '/account/services', label: 'Voir tous mes crédits' } : undefined}
      />
      {isLoading ? (
        <div className="mmv2-acct-wallets">
          <div className="mmv2-acct-skeleton mmv2-acct-skeleton--wallet" aria-busy="true" aria-label="Chargement de vos crédits" />
        </div>
      ) : shown.length ? (
        <ul className="mmv2-acct-wallets">
          {shown.map((service) => {
            const soon = isExpiringSoon(service);
            const expiration = toDate(service.ExpirationDate);
            return (
              <li key={service.Id} className={`mmv2-acct-wallet${soon ? ' mmv2-acct-wallet--soon' : ''}`}>
                <span className="mmv2-acct-wallet__name">{service.Name}</span>
                <span className="mmv2-acct-wallet__n">{service.Remaining}</span>
                <span className="mmv2-acct-wallet__meta">
                  {service.Count ? `restante${service.Remaining > 1 ? 's' : ''} sur ${service.Count}` : 'restantes'}
                  {expiration ? ` · expire le ${fmtDateExpiry(expiration)}` : ''}
                  {soon ? ' — bientôt' : ''}
                </span>
                {service.Count ? (
                  <span
                    className="mmv2-acct-wallet__bar"
                    role="progressbar"
                    aria-label={`${service.Remaining} séances restantes sur ${service.Count}`}
                    aria-valuemin={0}
                    aria-valuemax={service.Count}
                    aria-valuenow={service.Remaining}
                  >
                    <i style={{ width: `${walletPercent(service)}%` }} />
                  </span>
                ) : null}
              </li>
            );
          })}
        </ul>
      ) : (
        <div className="mmv2-acct-wallets">
          <div className="mmv2-acct-wallet mmv2-acct-wallet--empty">
            <span className="mmv2-acct-wallet__n">0</span>
            <span className="mmv2-acct-wallet__meta">Vous n’avez plus de crédit.</span>
            <Link className="mmv2-btn mmv2-btn--cta mmv2-btn--sm" to="/tarifs">
              Acheter des crédits
            </Link>
          </div>
        </div>
      )}
    </section>
  );
}
